export const CAMERA_ONBOARDING_TEST_IDS = {
  CVAPPS_LICENSE_TYPE_REFRESH_BUTTON: "cvAppsLicenseType_refreshButton",
  CVAPPS_LICENSE_TYPE_NEXT_BUTTON: "cvAppsLicenseType_nextButton",
  CVAPPS_LICENSE_TYPE_LICENSE_RADIO_GROUP: "cvAppsLicenseType_licenseRadioGroup",
  CVAPP_SUB_CLOSE_ICON_MODAL: "cvAppSub_closeIconModal",
  CVAPP_SUB_BACK_BUTTON_GROUP_BUTTON: "cvAppSub_backButtonGroupButton",
  CVAPP_SUB_NEXT_BUTTON_GROUP_BUTTON: "cvAppSub_nextButtonGroupButton",
  ASSIGN_AREA_AND_NAME_AREA_SELECT: "assignAreaandName_areaSelect",
  ASSIGN_AREA_AND_NAME_NEW_AREA_INPUT: "assignAreaandName_newAreaInput",
  SAVE_BUTTON: "cameraOnboarding_saveButton",
  CANCEL_BUTTON: "cameraOnboarding_cancelButton",
  RETRY_MODAL_RETRY_BUTTON: "cameraOnboarding_retryModalRetryButton",
  RETRY_MODAL_SKIP_BUTTON: "cameraOnboarding_retryModalSkipButton",
  NOTIFICATION_CLOSE_BUTTON: "cameraOnboarding_notificationCloseButton",
  MAIN_ACTION_BUTTON: "cameraOnboarding_mainActionButton",
  NEAR_SIZE_MINUS_BUTTON: "cameraOnboarding_nearSizeMinusButton",
  NEAR_SIZE_PLUS_BUTTON: "cameraOnboarding_nearSizePlusButton",
  FAR_SIZE_MINUS_BUTTON: "cameraOnboarding_farSizeMinusButton",
  FAR_SIZE_PLUS_BUTTON: "cameraOnboarding_farSizePlusButton", 
  FAR_POSITION_MINUS_BUTTON: "cameraOnboarding_farPositionMinusButton",
  FAR_POSITION_PLUS_BUTTON: "cameraOnboarding_farPositionPlusButton",
  NEAR_SIZE_INPUT: "cameraOnboarding_nearSizeInput",
  FAR_SIZE_INPUT: "cameraOnboarding_farSizeInput",
  FAR_POSITION_INPUT: "cameraOnboarding_farPositionInput",
  CAMERA_NAME_INPUT: "cameraOnboarding_cameraNameInput",
  STREAM_NAME_INPUT: "cameraOnboarding_streamNameInput",
  SKIP_ADVANCED_STREAM_CONFIG_BUTTON: "cameraOnboarding_skipAdvancedStreamConfigButton",
  GO_ADVANCED_STREAM_CONFIG_BUTTON: "cameraOnboarding_goAdvancedStreamConfigButton",
  SUBSCRIBE_CONFIG_YES_BUTTON: "cameraOnboarding_subscribeConfigYesButton",
  SUBSCRIBE_CONFIG_LATER_BUTTON: "cameraOnboarding_subscribeConfigLaterButton",
  CAMERA_BLUR_RADIO_GROUP: "cameraOnboarding_cameraBlurRadioGroup",
  EDIT_REVIEW_TAB_BUTTON: "cameraOnboarding_editReviewTabButton",
  REVIEW_LATER_BUTTON: "cameraOnboarding_reviewLaterButton",
  REVIEW_ACTIVATE_APPS_BUTTON: "cameraOnboarding_reviewActivateAppsButton",
  CCD_LIMIT_MODAL_CLOSE_BUTTON: "cameraOnboarding_ccdLimitModalCloseButton",
  CCD_LIMIT_MODAL_CLOSE_BUTTON: "cameraOnboarding_ccdLimitModalCloseButton",
  FLOOR_PLAN_DROPDOWN: "cameraOnboarding_floorPlanDropdown",
  AUTOMATIC_CALIBRATION_LINK: "streamCalibration_automaticCalibrationLink",
  STREAM_CALIBRATION_BACK_BUTTON: "streamCalibration_backButton",
  STREAM_CALIBRATION_NEXT_BUTTON: "streamCalibration_nextButton",
  STREAM_CALIBRATION_RADIO_GROUP: "streamCalibration_radioGroup", 
  MANUAL_CALIBRATION_BACK_BUTTON: "streamManualCalibration_backButton", 
  MANUAL_CALIBRATION_SUBMIT_BUTTON: "streamManualCalibration_submitButton",
  CAMERA_INFO_LINK: "cvAppsLicenseType_cameraInfoLink",
  CAMERA_INFO_PAGELINK: "cvAppsLicenseType_cameraInfoPageLink",
  CVAPPS_LICENSE_TYPE_DEVICELINK: "cvAppsLicenseType_devicesLink"
}; 

export const CVAPPS_LICENSE_TYPE_MESSAGES = {
    ASSIGN_LICENSE_SUCCESSFUL: "License has been successfully assigned to the device.",
    ASSIGN_LICENSE_FAILED: "Error while assigning license. Please try again.",
    REGISTRATION_TITLE: "Stream calibration in progress",
    REGISTRATION_SUBTITLE: "Licenses and apps cannot be selected for a stream until it is calibrated. Refresh this page to check stream calibration status.",
    REFRESH_ALERT: "Refresh action in progress!",
    STREAM_DESCREPTIVE_TEXT: "Start by selecting a license to use for any stream you'd like to subscribe to apps on."
}

export const CVAPPS_LICENSE_TYPES = {
  NO_LICENSE: "nolicense"
}

export const FOVStatus = {
  ON_BOARDED: "Onboarded"
};

export const DEVICE_ACTION = {
  CAMERA_ONBOARDING : "cameraOnBoarding"
};

export const CALIBRATION_DEFAULTS = {
  FAR_POSITION: 100,
  NEAR_SIZE: 50,
  FAR_SIZE: 40,
};

export const DUPLICATE_CAM = "Duplicate camera name found"